import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from './Container';
import Button from './Button';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section style={{
      paddingTop: '6rem',
      paddingBottom: '6rem',
      backgroundColor: '#1A202C',
      overflow: 'hidden'
    }} className="hero-section">
      <Container>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '4rem',
          alignItems: 'center'
        }} className="hero-grid">
          
          {/* Left Column - Content */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            
            {/* Badge - Scarcity & Offer */}
            <div style={{
              display: 'inline-block',
              alignSelf: 'flex-start',
              color: '#10B981',
              background: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid rgba(16, 185, 129, 0.2)',
              padding: '0.5rem 1rem',
              borderRadius: '9999px',
              fontSize: '0.85rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              ✨ Early Access: 3 Μήνες Δωρεάν
            </div>

            <h1 style={{
              fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', // Responsive font size
              fontWeight: '800',
              color: 'white',
              lineHeight: '1.1',
              letterSpacing: '-0.02em'
            }} className="hero-title">
              Το ιατρείο σας σε <br />
              <span style={{ 
                background: 'linear-gradient(to right, #10B981, #3B82F6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>πλήρη έλεγχο.</span>
            </h1>
            
            <p style={{
              fontSize: '1.25rem',
              color: '#94a3b8',
              lineHeight: '1.6',
              maxWidth: '38rem'
            }}>
              Απελευθερώστε χρόνο από τη γραμματεία. Οργανώστε τα ραντεβού, το ιστορικό και τις υπενθυμίσεις σας με την πιο σύγχρονη πλατφόρμα για κτηνιάτρους.
            </p>
            
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1rem',
              marginTop: '1rem'
            }} className="hero-buttons">
              <Button 
                variant="primary" 
                size="lg" 
                style={{ padding: '1rem 2.5rem', fontWeight: '700', borderRadius: '0.75rem' }}
                onClick={() => navigate('/signup')}
              >
                Δοκιμάστε το δωρεάν
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                style={{ padding: '1rem 2.5rem', fontWeight: '600', borderRadius: '0.75rem' }}
                onClick={() => navigate('/pricing')}
              >
                Δείτε τα πλάνα
              </Button>
            </div>
            
            {/* Social Proof / Trust Mini Section */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
              marginTop: '1rem',
              paddingTop: '1.5rem',
              borderTop: '1px solid #2d3748'
            }}>
               <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#64748b', fontSize: '0.9rem' }}>
                <div style={{ display: 'flex' }}>
                  {[1, 2, 3, 4, 5].map((s) => (
                    <svg key={s} style={{ width: '1rem', height: '1rem', color: '#F59E0B' }} fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <span>Σχεδιασμένο για την ελληνική αγορά</span>
              </div>
            </div>
          </div>

          {/* Right Column - Illustration (The Calendar) */}
          <div style={{ position: 'relative' }} className="hidden lg:block">
            {/* Glow effect behind illustration */}
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '120%',
              height: '120%',
              background: 'radial-gradient(circle, rgba(16,185,129,0.1) 0%, transparent 70%)',
              zIndex: 0
            }}></div>

            <div style={{
              position: 'relative',
              background: '#1F2937',
              borderRadius: '1.5rem',
              padding: '2rem',
              border: '1px solid #374151',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
              zIndex: 1
            }}>
              {/* Calendar Header */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: 'white' }}>Φεβρουάριος 2026</h3>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                   <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#ef4444' }}></div>
                   <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fbbf24' }}></div>
                   <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#10b981' }}></div>
                </div>
              </div>
              
              {/* Calendar Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: '0.5rem',
                fontSize: '0.75rem',
                textAlign: 'center'
              }}>
                {['Δ', 'Τ', 'Τ', 'Π', 'Π', 'Σ', 'Κ'].map(d => (
                  <div key={d} style={{ color: '#4b5563', fontWeight: '700', paddingBottom: '0.5rem' }}>{d}</div>
                ))}
                {Array.from({ length: 28 }, (_, i) => i + 1).map(date => (
                  <div key={date} style={{
                    padding: '0.75rem 0',
                    borderRadius: '0.5rem',
                    color: date === 15 ? 'white' : '#9ca3af',
                    backgroundColor: date === 15 ? '#10B981' : 'transparent',
                    fontWeight: date === 15 ? '700' : '400',
                    border: date === 15 ? 'none' : '1px solid transparent'
                  }}>
                    {date}
                  </div>
                ))}
              </div>

              {/* Floating Success Card */}
              <div style={{
                position: 'absolute',
                bottom: '-20px',
                right: '-20px',
                background: '#10B981',
                padding: '1rem',
                borderRadius: '1rem',
                color: 'white',
                boxShadow: '0 10px 15px rgba(0,0,0,0.3)',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}>
                <div style={{ backgroundColor: 'rgba(255,255,255,0.2)', padding: '0.25rem', borderRadius: '50%' }}>
                  <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <div style={{ fontSize: '0.7rem', opacity: 0.9 }}>Επόμενο Ραντεβού</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: '700' }}>10:30 - "Λούκυ" (Check-up)</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;